import React, { useEffect, useState } from 'react';
import { CalendarClock, RefreshCw } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const STATUS = { active: 'Activo', expired: 'Vencido', cancelled: 'Cancelado', canceled: 'Cancelado', past_due: 'Pago pendiente', unpaid: 'Pago pendiente', inactive: 'Inactivo', suspended: 'Suspendido', unknown: 'Estado sin confirmar' };

export const AccountPlanSummary = ({ testid = 'fidem-plan' }) => {
  const { api } = useAuth();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const [version, setVersion] = useState(0);
  useEffect(() => {
    let live = true;
    setError(false);
    api.get('/fidem/account').then((r) => { if (live) setData(r.data); }).catch(() => { if (live) setError(true); });
    const refresh = () => setVersion((v) => v + 1);
    window.addEventListener('focus', refresh);
    return () => { live = false; window.removeEventListener('focus', refresh); };
  }, [api, version]);
  return (
    <section data-testid={testid} className="mt-4 min-w-0 border-y border-slate-700 py-3">
      {error ? <div className="flex items-center gap-2 text-xs text-amber-200"><p data-testid={`${testid}-error`}>No pude consultar tu plan.</p><button type="button" aria-label="Reintentar consulta del plan" data-testid={`${testid}-retry`} onClick={() => setVersion((v) => v + 1)}><RefreshCw className="h-4 w-4" /></button></div> : !data ? <p data-testid={`${testid}-loading`} className="text-xs text-slate-400">Consultando tu plan…</p> : <>
        <div className="flex flex-wrap items-center gap-2 text-sm"><CalendarClock className="h-4 w-4 shrink-0 text-sky-300" /><span data-testid={`${testid}-name`} className="font-semibold text-white">{data.plan_name}</span><span data-testid={`${testid}-status`} className="text-xs text-slate-400">{STATUS[data.status] || 'Estado sin confirmar'}</span></div>
        <p data-testid={`${testid}-remaining`} className={`mt-1 break-words text-xs ${data.status === 'expired' ? 'text-amber-200' : 'text-slate-300'}`}>{data.detail}</p>
      </>}
    </section>
  );
};